import { Component, OnInit, OnDestroy, Inject, HostListener, OnChanges, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Router } from '@angular/router';
import { MatAutocompleteTrigger } from '@angular/material';
import { JoyrideService } from 'ngx-joyride';
import * as _ from 'lodash';
/** D3 is used to read DOM elements and create charts  */
declare const d3: any;
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { DataEndosigService } from '../../services/data-endosig/data-endosig.service';
import { Question } from '../../models/question.class';
import { Entry } from '../../models/entry.class';
import { FormControl } from '@angular/forms';
import { ErrorCatchDialogComponent } from '../../dialogs/error-catch-dialog/error-catch-dialog.component';
import { FilterRadiobuttonPopupComponent } from '../../components/filter-radiobutton-popup/filter-radiobutton-popup.component';
import { UtilsService } from '../../services/utils/utils.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AxisOption } from '../../models/axisOption.class';
import { ConfigVariable } from '../../models/ConfigVariable.class';

/** Value when want to set default to todos  */
const ALL = 'Todos';
/** Value when want to set default to Ambos  */
const BOTH = 'Ambos';
/** Value when want to set default to Nacional  */
const NATIONAL = 'Nacional';
/** Value when want to set a categorical question */
const CATEGORICAL_QUESTION = 0;
/** Value when want to set ranking question */
const RANKING_QUESTION = 1;
/** Value when want to set continuos question */
const CONTINOUS_QUESTION = 2;

/**
 * EndosigGraphsComponent
 * Catch question selected and use it to render graphs module
 */
@Component({
  selector: 'app-endosig-graphs',
  templateUrl: './endosig-graphs.component.html',
  styleUrls: ['./endosig-graphs.component.scss']
})
export class EndosigGraphsComponent implements OnInit, OnDestroy, AfterViewInit {
  /** Main title HTML of ENDOSIG */
  sharetext: string;
  /** Boolean to display or not the page */
  sharePage: boolean;
  /**   */
  imageJPG: string;
  /** Boolean to display or not the slider  */
  showSlider: boolean;
  /** The source will always be Conapred (2018)  */
  source: string;
  /**It`s gonna contain all variables */
  variables: Question[];
  /** Autocomplete control for variables  */
  searchQuestionnaires: FormControl;
  /** Autocomplete control for topic  */
  searchTopic: FormControl;
  /** Autocomplete control for subtopic  */
  searchSubtopic: FormControl;
  /** Autocomplete control for question  */
  searchQuestion: FormControl;
  /** Value of selectedGroup */
  selectedGroup: string;
  /** Name of selected group  */
  selectedGroupName: PopulationGroup;
  /** Object structure for the topic that was selected */
  selectedTopic: { name: string, slug: string };
  /** Object structure for the subtopic that was selected */
  selectedSubtopic: { name: string, slug: string };
  /** Value of selectedQuestion */
  selectedQuestion: Question;
  /** Contains all name of topics in object structure  */
  allTopics: { name: string, slug: string }[];
  /** Contains all name of subtopics in object structure  */
  subtopics: { name: string, slug: string }[];
  /** Value of xAxis  */
  xAxis: AxisOption;
  /** Value of how the xAxis groups */
  xAxisGroupBy: AxisOption;
  /** Value of yAxis  */
  yAxis: AxisOption;
  /** Came from interface AxisOption */
  collapseBy: AxisOption;
  /** Value to check if bars are going to stack or not  */
  stackBy: boolean;
  /** Value of how to group  */
  groupedBy: string;
  /** Id of question in use  */
  questionId: string;
  /** Kind of chart selected  */
  selectedChart: string;
  /** Current url to share  */
  url: string;
  /** Value of size of bars label ticks  */
  fontBars: any;
  /** Auxiliar to fontBars  */
  resBars: any;
  /** Contain the value of topic when changed by selected  */
  filteredTopics: any = [];
  /** Contain the value of subtopic when changed by selected   */
  filteredSubtopics: any = [];
  /** Contain the value of Variable when changed by selected   */
  filteredVariables: any = [];
  /** All data from chart used to display it  */
  dataToDraw: Entry[] = [];
  /** Cames from the dattoDraw when considering filter options  */
  filteredData: Entry[];
  /** Contains params from url */
  subQueryParams: any;
  /** all values for AxisOptions */
  axisOptions: AxisOption[] = [];
  /** Values for options of xAxis*/
  xAxisOptions: AxisOption[] = [];
  /** Values for options of yAxis*/
  yAxisOptions: AxisOption[] = [];
  /** Object structure of options for group  */
  groupByOptions: { id: string, name: string, shortName: string }[] = [];
  /** Items for group */
  groupByItems: AxisOption[] = [];
  /** Kind of available charts on ENDOSIG */
  chartsEnabled = {
    bars: true,
    heatmap: true,
    spineplot: true,
  };
  /** Kind of filter Options available on ENDOSIG  */
  filterOptions: {
    unidad: string[],
    categories: string[],
    columns: string[],
    secondCategories: string[],
    secondColumns: string[]
  };
  /** Object containing the selected Filters  */
  selectedFilters = {};
  /** Array for value ranges of slider  */
  sliderMinMax: number[]; // Borrar?
  /** Kind  */
  chart: any; // Borrar?
  /** Contains the value of how to order chart */
  orderBy: string;
  /** Contains the value for options of chart legends*/
  legendOptions: Array<any>;
  /** Value of title for legends  */
  legendTitle: string;
  /** Object with options of how to sort  */
  sortBy = {
    showSortOptions: false,
    names: true,
    valuesAscending: false,
    valuesDescending: false
  };
  /** Object with options for color  */
  showColorsOptions = false;
  /** Object with options for size  */
  showSizeOption = false;
  /** Value to check if display filters or not */
  showFilters = false;
  /** Sacles of chart values  */
  scales: any;
  /** Value to check if display label options or not */
  showLabelsOptions = false;
  /** Value to check if enable Coeficiente or not  */
  enableCoeficiente = false;
  /** Contains values if chart type is scatter */
  backupScatter: any;
  /** Contain all varibles used in ENDOSIG  */
  allVariables: Question[];
  /** Value to check  if display loader spinner */
  loadingData: boolean;
  /** Value of loader spinner  */
  progress: any;
  /** Counts de progress os loader spinner  */
  counter: number;
  /** Value to check if shows popup or not */
  showPopup = true;
  /** True if variable has maultiple filters  */
  multipleFilters: boolean;
  /** Filters in object structure  */
  namedFilters: { name: string, slug: string, selected: string }[];
  /** True if page is viewed from a mobile size */
  switchViewMob = true;
  /** Array of available colors  */
  colors: string[];
  /** inner width of charts  */
  innerWidth: any;
  /** True if page is viewed from a mobile size  */
  enableMobileMenu: boolean;
  /** True when disable a checkbox  */
  checkboxDisabled = false;
  /** True for hide the subdivision */
  hideSubdivition: boolean;
  /** True if wants to display labels  */
  labelsVisible = false;
  /** Complete name of question  */
  generatedTitle: string;
  /** Colors for question with catergorical vars */
  categoricalPalettes: string[][];
  /** Array with every color palettes  */
  availablePalettes: string[][];
  /** Colors for question with sequential vars */
  sequentialPalettes: string[][];
  /** True for diable Modals  */
  disableModal: boolean;
  /** True for forbid yAxis change selections  */
  disabledYAxis: boolean;
  /** True for forbid xAxis change selections  */
  disabledXAxis: boolean;
  /** True to show the order  */
  showOrderBy: boolean;
  /** Array with Topics from variables */
  topicVariables: Array<any> = [];
  /** Array with Subtopics from variables  */
  subtopicVariables: Array<any> = [];
  /** Filtered names of topics to be unique  */
  topicsNames: any;
  /** Filtered names of subtopics to be unique  */
  subtopicsNames: any;
  /** Value for comment if question has it  */
  comment: string;
  /** Value of the the probabilistic size of sample used */
  sampleSize: string;
  /** Contains the value that cames from ConfigVariable interface */
  variableAutocompleteConfig: ConfigVariable;
  /** Autocomplete for topic */
  @ViewChild('mat0', { read: MatAutocompleteTrigger }) trigger: MatAutocompleteTrigger;
  /** Autocomplete for subtopic */
  @ViewChild('mat1', { read: MatAutocompleteTrigger }) trigger1: MatAutocompleteTrigger;
  /** Autocomplete for variable */
  @ViewChild('mat2', { read: MatAutocompleteTrigger }) trigger2: MatAutocompleteTrigger;

  /**
   * Constructor for main class of component
   * @param location Location Strategy
   * @param route Route
   * @param dbService Database service brings data for charts
   * @param utils Utilities service
   * @param router Routes for the module to flow trough the whole applicaton
   * @param dialog Component that show a dialog Pane
   * @param joyrideService Joyride just appears the first time the module is used
   * @param storage Creates a new `WebStorageService` instance that uses the specified (web) storage object as underlying backing storage.
   */
  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private dbService: DataEndosigService,
    public utils: UtilsService,
    private router: Router,
    private dialog: MatDialog,
    private readonly joyrideService: JoyrideService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService) {
  }

  /** Angular's lyfecicle main method. When module is loaded
   *  Do all functionallity
   */
  ngOnInit() {
    this.searchTopic = new FormControl();
    this.searchSubtopic = new FormControl();
    this.searchQuestion = new FormControl();
    this.categoricalPalettes = this.utils.getCategoricalColors();
    this.sequentialPalettes = this.utils.getSequentialColors();
    this.disabledXAxis = false;
    this.selectedChart = 'bars';
    this.setColorPalette();
    this.hideSubdivition = true;
    this.disableModal = true;
    this.loadingData = false;
    this.showOrderBy = true;
    this.source = 'Endosig (2018)';
    this.variableAutocompleteConfig = {
      selectedTopic: '',
      selectedSubtopic: '',
      selectedQuestion: undefined,
      mode: undefined
    };
    this.multipleFilters = true;
    this.counter = 0;
    this.scales = {};
    this.sharePage = false;
    this.showSlider = false;
    this.sharetext = 'CONAPRED - ENDOSIG';
    this.url = 'http://sindis.conapred.org.mx/estadisticas/endosig/'; // Current url to share
    this.xAxis = _.find(this.axisOptions, { slug: 'categories' }); // Default value for x axis
    this.yAxis = _.find(this.axisOptions, { type: 'linear' }); // Default value for y axis
    this.collapseBy = _.find(this.axisOptions, { type: 'linear' }); // Default value for y axis
    this.groupedBy = '';
    this.xAxisGroupBy = _.find(this.groupByItems, { slug: 'categories' });
    this.stackBy = false;
    this.sliderMinMax = [0, 1000];
    this.orderBy = 'categories';
    this.legendOptions = [];
    this.filterOptions = {
      unidad: ['Total', 'Porcentaje'],
      categories: [],
      columns: [],
      secondCategories: [],
      secondColumns: []
    };

    /** Get params from url  */
    this.subQueryParams = this.route.queryParams.subscribe(params => {
      this.route.params.subscribe(paramsRout => {
        this.questionId = paramsRout['idQuestion'];
        // Chart is selected
        if (params['chart'] && Object.keys(this.chartsEnabled).includes(params['chart'])) {
          this.selectedChart = params['chart'];
        } else {
          // Default chart
          this.selectedChart = 'bars';
        }
        this.setColorPalette();
        this.disabledYAxis = this.selectedChart === 'bars' ? true : false;
        if (this.questionId) {
          this.dbService.getCodebook() // Get all questions
            .subscribe(questions => {
              this.allVariables = questions;
              this.searchTopics(this.allVariables);
              this.searchSubtopics(this.allVariables);
              this.selectedQuestion = this.allVariables.find(o => o.questionId === this.questionId);
              this.variables = this.allVariables;

              if (this.variables && this.variables.length > 0 && !this.selectedQuestion) {
                this.selectedQuestion = this.variables[0];
              }
              this.selectedTopic = this.allTopics.find((o) => {
                return o.slug === this.selectedQuestion.topic;
              });
              this.selectedSubtopic = this.subtopics.find((o) => {
                return o.slug === this.selectedQuestion.subtopic;
              });
              this.searchTopic.setValue(this.selectedTopic);
              this.searchSubtopic.setValue(this.selectedSubtopic);
              this.searchQuestion.setValue(this.selectedQuestion);
              this.setOptions();
            }, error => {
              console.error(error);
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: error.error.message.toString() || error.statusText.toString() ||
                    error.error.toString() || error
                }
              });
            });
        }
      });
    });

    /** Autocomplete of topics */
    this.filteredTopics = this.searchTopic.valueChanges
      .pipe(
        startWith(''),
        map(topic => {
          if (Array.isArray(this.allTopics)) {
            return topic ? this.filterTopics(topic) : this.allTopics.slice().sort(this.sortGroups);
          } else {
            return [];
          }
        })
      );

    /**  Autocomplete of subtopics */
    this.filteredSubtopics = this.searchSubtopic.valueChanges
      .pipe(
        startWith(''),
        map(subtopic => {
          if (Array.isArray(this.subtopics)) {
            return subtopic ? this.filterSubtopics(subtopic) : this.subtopics.slice().sort(this.sortGroups);
          } else {
            return [];
          }
        })
      );
    /**  Autocomplete of Variables */
    this.filteredVariables = this.searchQuestion.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.variables)) {
            return variable ? this.filterVariables(variable) : this.variables.slice().sort(this.sortVariables);
          } else {
            return [];
          }
        })
      );
    this.innerWidth = window.innerWidth; // Get screen width for first time
    this.enableMobileMenu = this.innerWidth <= 600 ? true : false; // Enable 'interest variable menu' based on screem width
  }

  /** Angular's After view Init lyfecicle method, Works after the componet was rendered  */
  ngAfterViewInit() {
    this.trigger.panelClosingActions.subscribe(e => {
      this.searchTopic.setValue(this.selectedTopic);
    });
    this.trigger1.panelClosingActions.subscribe(() => {
      this.searchSubtopic.setValue(this.selectedSubtopic);
    });
    this.trigger2.panelClosingActions.subscribe(() => {
      this.searchQuestion.setValue(this.selectedQuestion);
    });
  }

  /**
   * Reads all variables topics hem making all of them lowercase
   * return all the topics used in ENDOSIG
   * @param name name of the topic is filtered
   */
  filterTopics(name) {
    this.selectTopic(name);
    if (typeof name === 'string') {
      return this.allTopics.filter(st =>
        st.slug.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['slug']) {
      return this.allTopics.filter(st =>
        st.slug.toLowerCase().indexOf(name['slug'].toLowerCase()) > -1);
    }
    return this.allTopics;
  }

  /**
   * Reads the variable's topics filter them making all of them lowercase
   * return all the subtopics used in ENDOSIG
   * @param name name of the subtopic is filtered
   */
  filterSubtopics(name) {
    if (typeof name === 'string') {
      this.variables = this.variables.filter(function (q) {
        return q.subtopic === name;
      });
      return this.subtopics.filter(st =>
        st.slug.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['slug']) {
      this.variables = this.variables.filter(function (q) {
        return q.subtopic === name['slug'];
      });
      return this.subtopics.filter(st =>
        st.slug.toLowerCase().indexOf(name['slug'].toLowerCase()) > -1);
    }
    return this.subtopics;
  }

  /**
   * Search for the topics in every variable
   * @param questions Means all questions in ENDOSIG
   */
  searchTopics(questions) {
    this.topicVariables = questions.map(obj => new Question(obj));
    const justTopic = _.flatten(questions.map(function (a) {
      return a.topic;
    }));

    this.topicsNames = _.uniq(justTopic).filter(g => g);

    this.allTopics = this.topicsNames.map((e) => {
      return { name: e, slug: e };
    });
  }

  /**
   * Search for the subtopics in every variable
   * @param questions Means all questions in ENDOSIG
   */
  searchSubtopics(questions) {
    this.subtopicVariables = questions.map(obj => new Question(obj));
    const justSubtopics = _.flatten(questions.map(function (a) {
      return a.subtopic;
    }));

    this.subtopicsNames = _.uniq(justSubtopics).filter(g => g);

    this.subtopics = this.subtopicsNames.map((e) => {
      return { name: e, slug: e };
    });
  }

  /**
   * Returns the value of topic selcted by user
   * @param event Event object with name of topic selected
   */
  selectTopic(event) {
    this.selectedTopic = this.searchTopic.value;
    this.subtopicVariables = this.allVariables.filter((o: Question) => {
      return o.topic === this.selectedTopic.slug;
    });
    const justSubtopic = _.flatten(this.subtopicVariables.map(function (a) {
      return a.subtopic;
    }));

    this.subtopicsNames = _.uniq(justSubtopic).filter(g => g);

    this.subtopics = this.subtopicsNames.map((e) => {
      return { name: e, slug: e };
    });
    this.searchSubtopic.setValue(undefined);
    this.searchQuestion.setValue(undefined);
    return this.subtopics;
  }

  /**
   * Returns the value of subtopic selcted by user
   * @param event Event object with name of subtopic selected
   */
  selectSubtopic(event) {
    this.selectedSubtopic = this.searchSubtopic.value;
    this.variables = this.subtopicVariables.filter((o: Question) => {
      this.searchQuestion.setValue(undefined);
      return o.subtopic === this.selectedSubtopic.slug;
    });
  }

  /**
   * Set available color palette, depending on selected chart
   */
  setColorPalette() {
    if (_.includes(['heatmap'], this.selectedChart)) {
      this.availablePalettes = this.sequentialPalettes;
    } else {
      this.availablePalettes = this.categoricalPalettes;
    }
    this.colors = this.availablePalettes[0];
  }

  /**
   * Change the color of the gpah dependign on palette selected
   * @param palette Kind of palette used after user click change
   */
  onPaletteChanged(palette) {
    this.colors = palette;
    this.colorCheckboxes();
  }

  /** Read the filters selectd by user and assing them to const "copy" */
  includeFilters() {
    const copy = Object.assign({}, this.filterOptions);
    let colorGroup = true;

    if (this.selectedGroupName && this.selectedGroupName.slug !== 'Cuestionario de opiniones y experiencias' &&
      this.selectedGroupName.slug !== 'Características sociodemográficas') {
      colorGroup = false;
    }

    if (this.selectedQuestion && this.selectedQuestion.kind === 'fila') {
      delete copy.columns;
    }
    if (this.selectedQuestion && this.selectedQuestion.kind === 'fila') {
      delete copy.secondColumns;
    }
    if (this.selectedQuestion && this.selectedQuestion.expFactor !== 'factor_expansion') {
      delete copy['estado_residencia'];
    }
    if (this.selectedGroup === 'Personas adultas mayores') {
      delete copy['rango_edad'];
    }
    return copy;
  }

  /** Check the kind of question and data for each and generate filters for each question  */
  generateNamedFilters() {
    if (this.selectedFilters && this.selectedQuestion) {
      const fields = _.cloneDeep(this.selectedQuestion['fieldOptions']);
      if (this.selectedQuestion['kind'] === 'columna') {
        fields.push({ name: this.selectedQuestion['categoryName'], slug: 'columns', options: [] });
        fields.push({ name: this.selectedQuestion['subcategoryName'], slug: 'categories', options: [] });
      } else {
        fields.push({ name: this.selectedQuestion['categoryName'], slug: 'categories', options: [] });
      }
      this.namedFilters = Object.keys(this.selectedFilters).filter(o => {
        return _.includes(fields.map(f => f.slug), o);
      }).map(function (o) {
        const found = fields.find(f => f.slug === o);
        return {
          name: found.name,
          slug: o,
          selected: this.selectedFilters[o]
        };
      }.bind(this));
    }
  }

  /**
   * Generate dynamic title for current chart
   */
  generateTitle() {
    let title = '';
    // Selected question
    if ((this.selectedChart === 'bars' || 'spineplot' || 'heatmap') && this.selectedQuestion) {
      title += this.selectedQuestion.question;
    }
    if (this.selectedGroupName && this.selectedGroupName.name) {
      title += ' (' + (this.selectedFilters['rango_edad'] !== 'Todos' ?
        this.selectedGroupName.name.replace(/ *\([^)]*\) */g, '') : this.selectedGroupName.name) + ')';
    }
    return title;
  }
  /** Creates the large string with filters selected down the name of question  */
  generateFiltersText() {
    let filtersText = '';
    if (this.filterOptions['columns'].length > 2) {
      filtersText += this.selectedQuestion ? this.selectedQuestion.categoryName + ': ' : 'Variable: ';
      filtersText += this.selectedFilters ? this.selectedFilters['columns'] + ' / ' : ' / ';
    }
    filtersText += this.selectedQuestion ? this.selectedQuestion.subcategoryName || this.selectedQuestion.categoryName : 'Categoría';
    filtersText += ': ';
    filtersText += this.selectedFilters ? this.selectedFilters['categories'] + ' / ' : ' / ';
    filtersText += 'OSIG: ';
    filtersText += this.selectedFilters ? this.selectedFilters['osig'] + ' / ' : ' / ';
    filtersText += 'Grupo de edad: ';
    filtersText += this.selectedFilters ? this.selectedFilters['edadgrup'] + ' / ' : ' / ';
    if (this.collapseBy && this.collapseBy.slug === 'factor_expansion') {
      filtersText += 'Entidad federativa: ';
      filtersText += this.selectedFilters ? this.selectedFilters['estado_residencia'] + ' / ' : ' / ';
    }

    return filtersText;
  }

  /**
   * When x axis is selected
   */
  selectXAxis() {
    if (this.xAxis.slug === 'categories'
      && this.yAxis.type === 'ordinal'
      && this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION
      && this.selectedChart !== 'heatmap'
      && this.selectedChart !== 'spineplot') {
      this.selectedFilters['unidad'] = 'Promedio';
    }
    if (this.xAxis.slug === this.selectedQuestion.expFactor) {
      this.selectedFilters['unidad'] = 'Porcentaje';
    }
    // If selectedChart is 'bars'
    if (this.selectedChart === 'bars') {
      if (this.xAxis.slug === 'categories') {
        this.groupedBy = '';
        if (this.selectedFilters['categories'] !== this.filterOptions[this.xAxis.slug][0] &&
          this.selectedQuestion.kind === 'columna') {
          this.groupedBy = 'columns';
        }
        this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
      } else if (this.selectedQuestion.kindAnswer !== CONTINOUS_QUESTION &&
        this.selectedFilters['categories'] === this.filterOptions[this.xAxis.slug][0]) {
        // Si la pregunta puede ser subdidivida por respuestas y no está un filtro único
        this.groupedBy = 'categories';
        this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
      } else {
        this.groupedBy = '';
        this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
      }
    }
    if (this.selectedFilters[this.xAxis.slug] && !this.selectedQuestion.filterFirst) {
      this.selectedFilters[this.xAxis.slug] = this.filterOptions[this.xAxis.slug][0];
      if (this.selectedQuestion.relativePercentage && this.xAxis.slug === 'categories') {
        this.selectedFilters['categories'] = this.filterOptions['categories'][1];
      }
    }
    this.showFilterPopup();
  }

  /**
   * When y axis is selected
   */
  selectYAxis() {
    if (this.yAxis.slug === 'categories'
      && this.xAxis.type === 'ordinal'
      && this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION
      && this.selectedChart !== 'heatmap'
      && this.selectedChart !== 'spineplot') {
      this.selectedFilters['unidad'] = 'Promedio';
    }
    if (this.yAxis.slug === this.selectedQuestion.expFactor) {
      this.selectedFilters['unidad'] = 'Porcentaje';
    }
    this.selectedFilters['categories'] = this.filterOptions['categories'][0];
    if (this.yAxis.slug === 'columns') {
      this.selectedFilters['columns'] = this.filterOptions['columns'][0];
    }
    if (this.selectedChart === 'heatmap') { // Heatmap
      this.groupedBy = this.yAxis.slug;
      this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.yAxis.slug });
    }
    this.showFilterPopup();
  }

  /**
   * When Axisfilters have subfilters, and clicked to change
   * shows the options to axis subfilters
   */
  showFilterPopup() {
    const options = ['categories'];
    if (this.selectedQuestion.kind === 'columna') {
      options.unshift('columns');
    }
    const intersection = _.intersection(options, [this.xAxis.slug, this.yAxis.slug, this.groupedBy]);
    const difference = _.difference(options, intersection);
    if (difference.length > 0) {
      const config = this.filtersConfig();
      this.disableModal = config.disabled[difference[0]];
      if (!this.disableModal) {
        if (difference.includes('columns')) {
          this.selectedFilters['columns'] = this.selectedFilters['columns'] === 'Todos' ?
            this.filterOptions['columns'][1] : this.selectedFilters['columns'];
        } else {
          this.selectedFilters['columns'] = this.filterOptions['columns'][0];
        }

        if (difference.includes('categories')) {
          this.selectedFilters['categories'] = this.selectedFilters['categories'] === 'Todos' ?
            this.filterOptions['categories'][1] : this.selectedFilters['categories'] === '' ?
              this.selectedFilters['categories'] = 'Todos' : this.selectedFilters['categories'];
        } else {
          if (this.selectedQuestion.relativePercentage || this.selectedQuestion.filterFirst) {
            this.selectedFilters['categories'] = this.filterOptions['categories'][1];
          } else {
            this.selectedFilters['categories'] = this.filterOptions['categories'][0];
          }
        }
        const dialogRef = this.dialog.open(FilterRadiobuttonPopupComponent, {
          panelClass: 'white-themed-dialog',
          height: '400px',
          width: '500px',
          data: {
            blocks: difference,
            config: config,
            filterOptions: {
              columns: this.filterOptions['columns'].filter(o => !_.includes([ALL, BOTH, NATIONAL], o)),
              categories: this.filterOptions['categories'].filter(o => !_.includes([ALL, BOTH, NATIONAL], o))
            },
            selectedFilters: this.selectedFilters
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.updateChart();
        });
      } else {
        setTimeout(() => {
          this.updateChart();
        }, 100);
      }
    } else {
      setTimeout(() => {
        this.updateChart();
      }, 100);
    }
  }

  /**
   * Read which kind of graph is selected (Default is bars)
   * Create the default values for axes
   * Call function to create values for filters
   * And check and assign values according which groupby value has each axes
   */
  setDefaultAxes() {
    const vm = this;
    if ((this.selectedChart === 'bars' || 'spineplot' || 'heatmap') &&
      this.backupScatter && this.backupScatter.hasOwnProperty('xAxis')) {
      this.xAxis = this.backupScatter.xAxis;
      this.yAxis = this.backupScatter.yAxis;
    }
    if (this.axisOptions.length > 0) {
      this.groupedBy = '';
      this.generateSelectedFilters();
      this.collapseBy = _.find(this.axisOptions, { type: 'linear' });
      if (this.selectedQuestion && this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION) {
        this.collapseBy = _.find(this.axisOptions, { slug: 'categories' });
      }
      switch (this.selectedChart) {
        case 'bars': // Bars
          this.xAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'ordinal' ||
              (o.slug === 'categories' && this.selectedQuestion.kindAnswer === RANKING_QUESTION);
          }.bind(this)).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'linear' ||
              (o.slug === 'categories' && this.selectedQuestion.kindAnswer === RANKING_QUESTION);
          }.bind(this));
          this.xAxis = _.find(this.axisOptions, { slug: 'categories', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'columns', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'year', type: 'ordinal' })
            || _.find(this.axisOptions, { type: 'ordinal' });
          this.yAxis = _.find(this.axisOptions, { slug: 'categories', type: 'linear' })
            || _.find(this.axisOptions, { slug: this.selectedQuestion.expFactor })
            || _.find(this.axisOptions, { type: 'linear' });
          if (this.yAxis && this.yAxis.slug === 'categories') {
            this.selectedFilters['unidad'] = 'Promedio';
          }
          if (this.selectedQuestion.filterFirst) {
            this.selectedFilters['categories'] = this.filterOptions['categories'][1];
          }
          if (this.selectedQuestion.relativePercentage) {
            this.xAxis = _.find(this.axisOptions, { slug: 'categories' });
            if (this.selectedQuestion.kind === 'columna') {
              this.selectedFilters['categories'] = 'Sí';
              this.xAxis = _.find(this.axisOptions, { slug: 'columns' });
              this.groupedBy = '';
              this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
              if (this.xAxisGroupBy === undefined) {
                this.xAxisGroupBy = { name: '', type: 'ordinal', slug: '' };
              }
            }
          } else {
            if (this.selectedQuestion.kind === 'columna') {
              this.xAxis = _.find(this.axisOptions, { slug: 'columns' });
              if (this.selectedQuestion.filterFirst) {
                this.groupedBy = '';
              } else {
                this.groupedBy = 'categories';
              }
              this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
            } else {
              this.xAxis = _.find(this.axisOptions, { slug: 'categories', type: 'ordinal' }) ||
                _.find(this.axisOptions, { type: 'ordinal' });
              this.groupedBy = '';
            }
          }
          break;
        case 'heatmap': // Heatmap
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.xAxis = _.find(this.axisOptions, { slug: 'categories', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'columns', type: 'ordinal' }) || _.find(this.xAxisOptions, { slug: 'estado_residencia' });
          this.yAxis = this.yAxisOptions.filter(o => o.type === 'ordinal' && o.slug !== vm.xAxis.slug)[0];
          if (this.yAxis) {
            this.groupedBy = this.yAxis.slug;
            this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
          }
          this.showFilterPopup();
          break;
        case 'spineplot': // Spineplotthis.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal' );
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'ordinal';
          }.bind(this)).sort((a, b) => a.name < b.name ? -1 : 1);

          this.xAxis = _.find(this.xAxisOptions, { slug: 'categories' });
          this.yAxis = this.yAxisOptions.filter(o => o.type === 'ordinal' && o.slug !== vm.xAxis.slug)[0];

          if (this.yAxis) {
            this.groupedBy = this.yAxis.slug;
            this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
          }

          if (this.yAxis.slug === this.xAxis.slug) {
            this.xAxis = _.find(this.xAxisOptions, { slug: 'estado_residencia', type: 'ordinal' });
          }
          this.showFilterPopup();
          break;
        default:
          this.xAxis = _.find(this.axisOptions, { slug: 'categories' });
          this.yAxis = _.find(this.axisOptions, { slug: 'rango_edad' });
          this.xAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          break;
      }
    }

    if (this.selectedQuestion && this.selectedQuestion.kind === 'columna' &&
      this.xAxis && this.xAxis.slug !== 'columns' && this.selectedChart !== 'timeline') {
      this.selectedFilters['columns'] = ALL;
      this.groupedBy = 'columns';
      this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
    }
    if (this.disabledXAxis) {
      this.disabledYAxis = !this.disabledYAxis;
      this.disabledXAxis = !this.disabledXAxis;
    }
  }

  /**
   * Check the type of yaxis selected and assign a type for xAxis and viceverse
   * Also depending of kind of chart assign values and types for both axes
   */
  checkAxesSelected() {
    if (this.xAxis && this.xAxis.slug === 'categories') {
      this.xAxis.type = 'ordinal';
      if (this.selectedQuestion.kindAnswer === RANKING_QUESTION && this.selectedChart !== 'heatmap'
        && this.selectedChart !== 'spineplot') {
        if (this.yAxis.type === 'ordinal') {
          this.xAxis.type = 'linear';
        } else {
          this.xAxis.type = 'ordinal';
        }
      } else if (this.selectedQuestion.kindAnswer === CONTINOUS_QUESTION) {
        this.xAxis.type = 'linear';
      }
    }
    if (this.yAxis && this.yAxis.slug === 'categories') {
      this.yAxis.type = 'ordinal';
      if (this.selectedQuestion && this.selectedQuestion.kindAnswer === RANKING_QUESTION && this.selectedChart !== 'heatmap'
        && this.selectedChart !== 'spineplot') {
        if (this.xAxis.type === 'ordinal') {
          this.yAxis.type = 'linear';
        } else {
          this.yAxis.type = 'ordinal';
        }
      } else if (this.selectedQuestion && this.selectedQuestion.kindAnswer === CONTINOUS_QUESTION) {
        this.yAxis.type = 'linear';
      }
    }
    if (this.xAxis && this.xAxis.slug === this.selectedQuestion.expFactor ||
      this.yAxis && this.yAxis.slug === this.selectedQuestion.expFactor) {
      if (this.selectedFilters['unidad'] === 'Promedio') {
        this.selectedFilters['unidad'] = 'Porcentaje';
      }
    }

    /**
     * Set collapseBy column
     */
    switch (this.selectedChart) {
      case 'bars': // Bars
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis && this.yAxis.type === 'ordinal' && this.xAxis && this.xAxis.type === 'ordinal') {
          this.yAxis = _.find(this.axisOptions, { slug: 'categories', type: 'linear' })
            || _.find(this.axisOptions, { type: 'linear' });
        }
        if (this.yAxis && this.yAxis.type === 'linear' && this.xAxis && this.xAxis.type === 'linear') {
          this.xAxis = _.find(this.axisOptions, { type: 'ordinal' });
        }
        // d3.select('#ChangeSize').style('display', 'block');
        // d3.select('.label-drop-masmenos').style('display', 'block');
        break;
      case 'heatmap': // Heatmap
        if (this.yAxis.type === 'linear') {
          this.yAxis = _.find(this.axisOptions.reverse(), { type: 'ordinal' });
        }
        if (this.xAxis.type === 'linear') {
          if (this.xAxis.slug === 'categories' && this.selectedFilters['unidad'] !== 'Promedio') {
            this.xAxis.type = 'ordinal';
          } else {
            this.xAxis = _.find(this.axisOptions, { type: 'ordinal' });
          }
        }
        break;
      case 'spineplot': // Spineplot
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis.type === 'linear' && this.xAxis.type === 'linear') {
          this.xAxis = _.find(this.axisOptions, { slug: 'rango_edad' });
        }
        if (this.yAxis.type !== 'linear') {
          this.groupedBy = this.yAxis.slug;
          this.xAxisGroupBy = _.find(this.groupByItems, { slug: this.groupedBy });
        }
        break;
      default:
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis.type === 'ordinal' && this.xAxis.type === 'ordinal') {
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
        }
        break;
    }

    const linearAxis = _.find([this.yAxis, this.xAxis], { 'type': 'linear' });
    this.collapseBy = linearAxis ? linearAxis :
      this.selectedFilters['unidad'] === 'Promedio' && this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION ?
        _.find(this.axisOptions, { slug: 'categories' }) : _.find(this.axisOptions, { type: 'linear' });
  }

  /**
   * Validates if filteres are different to defaults and if are less than 2
   * @param filters filters selected by user
   */
  validateFilters(filters) {
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], filters[this.groupedBy])) {
      this.groupedBy = '';
    }
    const keys = Object.keys(filters);
    const values = Object.values(filters);
    const filtered = values.filter(o => !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], o));

    if (filtered.length > 2) {
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'No es posible seleccionar más de dos filtros, por favor cambia tu selección'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  /**
   * If Filters are different to defaults and if are less than 2
   * calls method to updatechart using new values
   * @param filters Filters selected by user
   */
  updateFilters(filters) {
    this.showFilters = false;
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], filters[this.groupedBy])) {
      this.groupedBy = '';
    }
    const keys = Object.keys(filters);
    const values = Object.values(filters);
    const filtered = values.filter(o => !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], o));

    if (filtered.length > 2) {
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'No es posible seleccionar más de dos filtros, por favor cambia tu selección'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    } else {
      setTimeout(() => {
        this.updateChart();
      }, 100);
    }
  }
  /**
   * Sets Topic autocomplete to null value
   */
  setTopic() {
    this.searchTopic.setValue(undefined);
  }

  /**
   * Get initial options from selected question
   */
  setOptions() {
    this.sampleSize = 'N/D';
    // Set filterOptions
    this.filterOptions = {
      unidad: ['Total', 'Porcentaje'],
      categories: [],
      columns: [],
      secondCategories: [],
      secondColumns: []
    };
    this.selectedFilters = {};
    // Get columns
    const obsColumns = this.dbService.getColumnsFromQuestionId(this.selectedQuestion.questionId);
    const obsCategories = this.dbService.getRowsFromQuestionId(this.selectedQuestion.questionId);

    forkJoin(obsColumns, obsCategories).subscribe(res => {
      this.filterOptions.columns = [ALL].concat(_.uniq(res[0].map(o => o['name'])
        .filter(opt => opt !== 'No contestó' && opt !== 'No aplica')
        .sort(this.sortAll)));
      this.filterOptions.categories = [ALL].concat(_.uniq(res[1].map(o => o['name'])
        .filter(opt => opt !== 'No contestó' && opt !== 'No aplica')
        .sort(this.sortAll)));

      if (this.selectedQuestion.fieldOptions) {
        _.forEach(this.selectedQuestion.fieldOptions, function (fo) {
          const filterAbv = fo['slug'];
          let dbOpts;
          let completeOpts;

          dbOpts = _.uniq(fo['options'].map(d => d['name']).sort(this.sortAll));

          if (filterAbv === 'estado_residencia') {
            completeOpts = [NATIONAL].concat(dbOpts as string[]);
          } else {
            completeOpts = [ALL].concat(dbOpts as string[]);
          }
          this.filterOptions[filterAbv] = completeOpts;
        }.bind(this));
      }

      if (this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION) {
        this.filterOptions.unidad.push('Promedio');
      }

      this.collapseBy = this.selectedQuestion.kindAnswer === CATEGORICAL_QUESTION ?
        this.axisOptions.find(o => o.slug === this.selectedQuestion.expFactor) :
        this.axisOptions.find(o => o.slug === 'categories');

      this.generateSelectedFilters();
      this.setAxisOptions();

      if (this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION) {
        this.selectedFilters['unidad'] = 'Promedio';
        const idx = _.findIndex(this.axisOptions, o => o.slug === 'categories');
        this.axisOptions[idx]['type'] = 'linear';
      } else {
        this.selectedFilters['unidad'] = 'Porcentaje';
      }

      this.generateGroupItems();
      this.setDefaultAxes();
      this.showFilterPopup();
    }, err => {
      console.error(err);
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: err.error.message.toString() || err.statusText.toString()
        }
      });
    });
  }

  /**
   * Sorts Arrays containing values for filters in order especified down below
   * @param a First value to compare
   * @param b Second value to compare
   */
  sortAll(a: any, b: any) {
    const res = ['Sí', 'No'];

    const ages = [
      '0 a 5 años',
      '6 a 11 años',
      '9 a 11 años',
      '12 a 17 años',
      '18 a 29 años',
      '30 a 59 años',
      '60 o más años'
    ];

    const situation = [
      'Siempre',
      'Algunas veces',
      'Pocas veces',
      'Nunca',
      'No responde'];

    const education = [
      'Sin escolaridad',
      'Hasta primaria incompleta',
      'Primaria completa',
      'Secundaria completa',
      'Media superior',
      'Superior',
      'No especificado'];

    const frequency = [
      'Mucho',
      'Algo',
      'Poco',
      'Nada',
      'No sé',
      'No Sabe',
      'No aplica',
      'No respondió'];

    const quantity = [
      'Mucha',
      'Alguna',
      'Poca',
      'Nada',
      'No sabe'];

    const frequency2 = [
      'Muchas veces',
      'Algunas veces',
      'Pocas veces',
      'Nunca'];

    const estrato = [
      'Alto',
      'Medio alto',
      'Medio bajo',
      'Bajo'];

    const skinColor = [
      'Más obscuro',
      'Intermedio',
      'Más claro'];

    const osig = [
      'Gay',
      'Lesbiana',
      'Mujer bisexual',
      'Hombre bisexual',
      'Persona con otra orientación sexual no normativa',
      'Hombre trans',
      'Mujer trans',
      'Persona con otra identidad de género no normativa',
    ];

    const edadgrup = [
      'Adolescentes',
      'Personas jóvenes',
      'Personas adultas',
      'Personas mayores',
    ];

    if (_.includes(ages, a) && _.includes(ages, b)) {
      return ages.indexOf(a) - ages.indexOf(b);
    } else if (_.includes(situation, a) && _.includes(situation, b)) {
      return situation.indexOf(a) - situation.indexOf(b);
    } else if (_.includes(education, a) && _.includes(education, b)) {
      return education.indexOf(a) - education.indexOf(b);
    } else if (_.includes(frequency, a) && _.includes(frequency, b)) {
      return frequency.indexOf(a) - frequency.indexOf(b);
    } else if (_.includes(frequency2, a) && _.includes(frequency2, b)) {
      return frequency2.indexOf(a) - frequency2.indexOf(b);
    } else if (_.includes(quantity, a) && _.includes(quantity, b)) {
      return quantity.indexOf(a) - quantity.indexOf(b);
    } else if (_.includes(res, a) && _.includes(res, b)) {
      return res.indexOf(a) - res.indexOf(b);
    } else if (_.includes(estrato, a) && _.includes(estrato, b)) {
      return estrato.indexOf(a) - estrato.indexOf(b);
    } else if (_.includes(skinColor, a) && _.includes(skinColor, b)) {
      return skinColor.indexOf(a) - skinColor.indexOf(b);
    } else if (_.includes(osig, a) && _.includes(osig, b)) {
      return osig.indexOf(a) - osig.indexOf(b);
    } else if (_.includes(edadgrup, a) && _.includes(edadgrup, b)) {
      return edadgrup.indexOf(a) - edadgrup.indexOf(b);
    } else if (a.toLowerCase() === 'otro' || a.toLowerCase() === 'otra' || a === 'No sabe' || a === 'No aplica') {
      return 1;
    } else if (b.toLowerCase() === 'otro' || b.toLowerCase() === 'otra' || b === 'No sabe' || b === 'No aplica') {
      return -1;
    } else {
      if (!Number.isNaN(+a) && !Number.isNaN(+b)) {
        // If both values are numbers use numeric value
        return Number(a) - Number(b);
      } else if (!Number.isNaN(+a) && Number.isNaN(+b)) {
        return -1;
      } else if (Number.isNaN(+a) && !Number.isNaN(+b)) {
        return 1;
      } else if (a <= b) {
        return -1;
      } else {
        return 1;
      }
    }
  }

  /**
   * Sets the value of filter options for both axes
   * Check the kindof question in use
   */
  setAxisOptions() {
    const collapseBy = this.selectedGroupName ? this.selectedGroupName.collapseBy : this.selectedQuestion.expFactor;

    this.axisOptions = [
      { name: 'Cantidad de personas', slug: collapseBy, type: 'linear' }
    ];
    this.selectedQuestion.fieldOptions.forEach(opt => {
      if (!_.find(this.axisOptions, ax => ax.slug === opt.slug)) {
        this.axisOptions.push({
          name: opt.name,
          slug: opt.slug,
          type: 'ordinal'
        });
      }
    });
    if (this.selectedQuestion.kind === 'columna') {
      this.axisOptions.push({ name: this.selectedQuestion.categoryName, slug: 'columns', type: 'ordinal' });
      this.axisOptions.push({ name: this.selectedQuestion.subcategoryName, slug: 'categories', type: 'ordinal' });
    } else if (this.selectedQuestion.kind === 'fila') {
      this.axisOptions.push({
        name: this.selectedQuestion.categoryName || this.selectedQuestion.shortName,
        slug: 'categories', type: 'ordinal'
      });
    }
  }

  /**
   * Sets the selected groupBy in the drowpdown
   * @param xAxisGroupBy Value selected for how to group xAxis options
   */
  selectXAxisGroupBy(xAxisGroupBy) {
    this.xAxisGroupBy = xAxisGroupBy;
    this.groupBy(this.xAxisGroupBy.slug);
  }
  /** Calls function above, this function is called on a submit button  */
  onSelectXAxisGroupBy() {
    this.selectXAxisGroupBy(this.xAxisGroupBy);
  }
  /**
   * Group the options of axis
   * @param item Name of the group the options are goiing to group by
   */
  groupBy(item) {
    if (!((this.xAxis && item === this.xAxis.slug) || ((this.yAxis && item === this.yAxis.slug) && this.selectedChart === 'bars'))) {
      this.groupedBy = item;
      if (item) {
        this.selectedFilters[item] = this.filterOptions[item][0];
      }
    }
    if (this.selectedChart === 'heatmap') { // Heatmap
      if (item) {
        this.yAxis = _.find(this.yAxisOptions, { slug: this.groupedBy });
      } else {
        this.yAxis = _.find(this.yAxisOptions, { type: 'ordinal' });
        this.groupedBy = this.yAxis.slug;
      }
    }
    if (this.selectedChart === 'spineplot') { // Spineplot
      if (item) {
        this.yAxis = _.find(this.yAxisOptions, { slug: this.groupedBy });
      } else {
        this.yAxis = _.clone(this.collapseBy);
      }
    }
    this.showFilterPopup();
  }

  /**
   * Reads global variables and process them to generate new chart
   * Calls functions that sets default values
   */
  updateChart() {
    const vm = this;
    this.updateUrl();
    this.generatedTitle = this.generateTitle();
    // Show loading text while updating chart
    d3.select('.empty-chart').selectAll('*').remove();
    d3.selectAll('.d3-tip').remove();
    d3.selectAll('.title-tip').remove();
    d3.select('.empty-chart').text('CARGANDO GRÁFICA...');
    if (this.selectedChart && this.selectedQuestion && this.xAxis && this.yAxis) {
      this.checkAxesSelected();
      this.generateNamedFilters();
      /**
       * redraw selected chart
       * Get data to draw chart
       */
      const selectedFilters = _.cloneDeep(this.selectedFilters);
      const xAxis = this.xAxis.slug;
      let expFactor = this.selectedGroupName ? this.selectedGroupName.collapseBy : this.selectedQuestion.expFactor;
      let yAxis = this.yAxis.slug === this.selectedQuestion.expFactor ? expFactor : this.yAxis.slug;
      let groupedBy = this.groupedBy + '';
      const collapseBy = this.collapseBy.slug;
      const project = {};
      if (this.selectedChart === 'bars') {
        if (this.yAxis.type === 'ordinal') {
          this.xAxisOptions[0].name = `${this.selectedFilters['unidad']} de personas`;
        } else {
          this.yAxisOptions[0].name = `${this.selectedFilters['unidad']} de personas`;
        }
      }
      if (this.selectedChart === 'heatmap' && groupedBy) {
        project[groupedBy] = 1;
        groupedBy = '';
      }
      if (this.selectedChart === 'spineplot') { // Spineplot
        yAxis = this.collapseBy.slug;
      }
      const keys = {
        xAxis: xAxis,
        yAxis: yAxis,
        groupBy: groupedBy,
        project: project,
        collapseBy: collapseBy,
        expFactor: expFactor
      };

      if (this.selectedQuestion.comment) {
        this.comment = this.selectedQuestion.comment;
      } else {
        this.comment = '';
      }

      if (this.selectedChart === 'bars' || 'spineplot' || 'heatmap') {
        if (this.selectedGroupName) {
          selectedFilters[this.selectedGroupName.dummy] = 1;
        }
        if (this.selectedQuestion.relativePercentage) {
          keys['relativePercentage'] = true;
        }
        this.loadingData = true;
        this.progress = setInterval(function () {
          if (vm.counter < 92) {
            vm.counter += Math.floor(Math.random() * (5 - 0 + 1)) + 0;
          }
        }, 600);
        this.dbService.getSampleSize(this.selectedQuestion.questionId, selectedFilters, keys)
          .subscribe(sampleSize => {
            this.sampleSize = d3.format(',.0f')(sampleSize) + ' personas';
          });
        this.dbService.getDataToDraw(this.selectedQuestion.questionId, selectedFilters, keys)
          .subscribe(dataToDraw => {
            d3.select('.empty-chart')
              .style('border', null)
              .text('');
            if (dataToDraw.length === 0) {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: 'No existen datos para esta pregunta'
                }
              });
              dialogRef.afterClosed().subscribe(result => {
                d3.select('.empty-chart')
                  .style('border', 'dashed 2px #ccc')
                  .text('NO EXISTEN DATOS PARA ESTA PREGUNTA');
              });
            }

            this.dataToDraw = dataToDraw;
            let min = Math.floor(d3.min(this.dataToDraw, d => d[collapseBy]));
            let max = Math.ceil(d3.max(this.dataToDraw, d => d[collapseBy]));
            if (min === max) {
              min -= 1;
              max += 1;
            }
            this.sliderMinMax = [min, max];

            /**
             * Get groupByOptions
             */
            if (this.filterOptions[this.groupedBy]) {
              this.groupByOptions = this.filterOptions[this.groupedBy].filter(o => o !== ALL && o !== BOTH && o !== NATIONAL);
            }

            this.sortChanged('names');
            clearInterval(this.progress);
            this.counter = 0;
            this.loadingData = false;
            this.startJoyride();
          }, error => {
            console.error(error);
            const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
              panelClass: 'light-themed-dialog',
              width: '400px',
              data: {
                error: error.error.message.toString() || error.statusText.toString() ||
                  error.message.toString() || error
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              clearInterval(this.progress);
              this.counter = 0;
              this.loadingData = false;
              this.router.navigate(['/content/endosig/explore'], {
                queryParams: {}
              });
            });
          });
      } else {
        if (this.selectedQuestion && this.selectedQuestion) {
          if (this.selectedQuestion.topic === 'Características de la vivienda' &&
            this.selectedQuestion) {
            expFactor = 'factor_expansion';
          }
          if (this.selectedQuestion.topic === 'Características sociodemográficas' &&
            _.includes(['Características de la vivienda', 'Características de los hogares'], this.selectedQuestion.topic)) {
            expFactor = 'factor_expansion';
          }
          if (_.includes([
            'Características sociodemográficas',
            'Características de los hogares',
            'Características de la vivienda'], this.selectedQuestion.topic)) {
            expFactor = this.selectedQuestion.collapseBy;
          }
          this.collapseBy = {
            name: 'Total', slug: this.selectedQuestion && this.selectedQuestion.kindAnswer !== CATEGORICAL_QUESTION &&
              this.collapseBy ? this.collapseBy.slug : expFactor, type: 'linear'
          };

          const firstFilters = _.cloneDeep(selectedFilters);
          delete firstFilters['secondCategories'];
          delete firstFilters['secondColumns'];

          const firstQuestion = {
            'keys': {
              'xAxis': 'categories',
              'yAxis': expFactor,
              'groupBy': groupedBy,
              'collapseBy': expFactor,
              'expFactor': expFactor,
              'project': project
            },
            'questionId': this.selectedQuestion.questionId,
            'selectedFilters': firstFilters
          };

          selectedFilters['columns'] = this.selectedFilters['secondColumns'] || ALL;
          selectedFilters['categories'] = this.selectedFilters['secondCategories'] || ALL;

          delete selectedFilters['secondCategories'];
          delete selectedFilters['secondColumns'];

          const secondQuestion = {
            'keys': {
              'xAxis': 'categories',
              'yAxis': expFactor,
              'groupBy': groupedBy,
              'collapseBy': expFactor,
              'expFactor': expFactor,
              'project': project
            },
            'questionId': this.selectedQuestion.questionId,
            'selectedFilters': selectedFilters
          };

          this.loadingData = true;
          this.progress = setInterval(function () {
            if (vm.counter < 92) {
              vm.counter += Math.floor(Math.random() * (5 - 0 + 1)) + 0;
            }
          }, 600);
          this.dbService.crossData(firstQuestion, secondQuestion)
            .subscribe(dataToDraw => {
              d3.select('.empty-chart')
                .style('border', null)
                .text('');
              if (dataToDraw.length === 0) {
                const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                  panelClass: 'light-themed-dialog',
                  width: '400px',
                  data: {
                    error: 'No existen datos para este cruce, cambia la segunda variable'
                  }
                });
                dialogRef.afterClosed().subscribe(result => {
                  d3.select('.empty-chart')
                    .style('border', 'dashed 2px #ccc')
                    .text('NO EXISTEN DATOS PARA ESTE CRUCE, CAMBIA LA SEGUNDA VARIABLE');
                });
              }

              /**
               * Get groupByOptions
               */
              if (this.filterOptions[this.groupedBy]) {
                this.groupByOptions = this.filterOptions[this.groupedBy].filter(o => o !== ALL && o !== BOTH && o !== NATIONAL);
              }
              this.xAxis = { name: this.selectedQuestion.shortName, slug: this.selectedQuestion.shortName, type: 'ordinal' };
              this.yAxis = { name: this.selectedQuestion.shortName, slug: this.selectedQuestion.shortName, type: 'ordinal' };

              this.dataToDraw = dataToDraw;

              this.sortChanged('names');
              clearInterval(this.progress);
              this.loadingData = false;
              this.counter = 0;
            }, error => {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: error.error.message.toString() || error.statusText.toString() ||
                    error.message.toString() || error
                }
              });
              dialogRef.afterClosed().subscribe(result => {
                clearInterval(this.progress);
                this.counter = 0;
                this.loadingData = false;
                this.router.navigate(['/content/endosig/explore'], {
                  queryParams: {}
                });
              });
            });
        }
      }
    }
  }

  /**
   * Only gets called when open the module for the first Time
   * Sets a variable to localStorage to forbid the execution of this function again
   */
  startJoyride() {
    if (!this.storage.get('joyrideDone')) {
      this.joyrideService.startTour(
        {
          steps: ['step1', 'step2', 'step4'],
          stepDefaultPosition: 'top',
        } // Your steps order
      ).subscribe(
        (step) => {
          // Do something
          d3.select('.joyride-step__next-container .joyride-button')
            .text('Siguiente');
          d3.select('.joyride-step__prev-container .joyride-button')
            .text('Anterior');
          d3.select('.joyride-step__done-button .joyride-button')
            .text('Terminar');
        },
        (error) => { /*handle error*/ },
        () => {
          /*Tour is finished here */
          this.storage.set('joyrideDone', true);
        }
      );
    }
  }

  /**
   * Triggered by app-question-dropdown-selection change
   * @param question - Question from ngModelChange
   */
  onChangeQuestion(config: { selectedQuestion: Question, selectedGroup: any }) {
    this.selectedQuestion = config.selectedQuestion;
    this.collapseBy.slug = config.selectedGroup;
    this.selectedGroupName = this.dbService.findGroup(config.selectedGroup);
    this.setOptions();
  }

  /**
   * Sets the url, to can access the module, sets values to params to make request to DB
   */
  updateUrl() {
    const urlTree = this.router.createUrlTree(['/content/endosig/explore/' + this.selectedQuestion.questionId], {
      queryParams: {
        chart: this.selectedChart,
        selectedTopic: this.selectedTopic.slug,
        selectedSubtopic: this.selectedSubtopic.slug
      },
      queryParamsHandling: 'merge',
      preserveFragment: true
    }).toString();
    this.location.go(urlTree);
  }

  /**
   * Parses Data if it is grouped by of if has an order or how it's the way
   * to collapse by the kind of chart
   * @param data All data going to be parsed
   * @param considerLegendOptions Boolean not strict necesary,
   * True when wants considerLegendOptions
   */
  parseData(data: Entry[], considerLegendOptions?: boolean): Entry[] {
    /** Refers to the context of this function  */
    const vm = this;
    /**
     * Sort data by this.orderBy
     */
    if (this.filterOptions[this.orderBy]) {
      this.showOrderBy = this.filterOptions[this.orderBy].length > 2 ? true : false;
    }
    if (this.selectedQuestion.relativePercentage && this.xAxis.slug === 'categories') {
      this.showOrderBy = false;
    }
    let resultData = _.cloneDeep(data).sort(function (a, b) {
      if (_.includes(this.filterOptions[this.orderBy], a[this.orderBy]) && _.includes(this.filterOptions[this.orderBy], b[this.orderBy])) {
        const res = ['Sí', 'No'];
        return this.filterOptions[this.orderBy].indexOf(a[this.orderBy]) - this.filterOptions[this.orderBy].indexOf(b[this.orderBy]);
      } else if (a[this.orderBy] === 'Otro' || a[this.orderBy] === 'No aplica') {
        return 1;
      } else if (b[this.orderBy] === 'Otro' || b[this.orderBy] === 'No aplica') {
        return -1;
      } else {
        if (this.sortBy.valuesAscending === true) {
          if (this.groupedBy && this.groupedBy !== this.xAxis.slug) {
            const firstValue = this.filterOptions[this.groupedBy][1] || 'totalByGroup';
            return Number(a[firstValue]) - Number(b[firstValue]);
          } else if (!Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            // If both values are numbers use numeric value
            return Number(a[this.orderBy]) - Number(b[this.orderBy]);
          } else if (!Number.isNaN(+a[this.orderBy]) && Number.isNaN(+b[this.orderBy])) {
            return -1;
          } else if (Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            return 1;
          } else if (a[this.orderBy] <= b[this.orderBy]) {
            return -1;
          } else {
            return 1;
          }
        } else if (this.sortBy.valuesDescending === true) {
          if (this.groupedBy && this.groupedBy !== this.xAxis.slug) {
            const firstValue = this.filterOptions[this.groupedBy][1] || 'totalByGroup';
            return Number(b[firstValue]) - Number(a[firstValue]);
          } else if (!Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            // If both values are numbers use numeric value
            return Number(b[this.orderBy]) - Number(a[this.orderBy]);
          } else if (!Number.isNaN(+a[this.orderBy]) && Number.isNaN(+b[this.orderBy])) {
            return 1;
          } else if (Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            return -1;
          } else if (a[this.orderBy] <= b[this.orderBy]) {
            return 1;
          } else {
            return -1;
          }
        }
      }
    }.bind(this)).filter(function (d) {
      return (!this.xAxis || this.xAxis && !this.filterOptions[this.xAxis.slug] || this.xAxis && this.xAxis.type === 'linear' ||
        this.xAxis && _.includes(this.filterOptions[this.xAxis.slug].map(o => o + ''), d[this.xAxis.slug] + '')
        || this.selectedFilters.estado_residencia === NATIONAL) &&
        (!this.yAxis || this.yAxis && !this.filterOptions[this.yAxis.slug] || this.yAxis && this.yAxis.type === 'linear' || this.yAxis &&
          _.includes(this.filterOptions[this.yAxis.slug].map(o => o + ''), d[this.yAxis.slug] + '')) ||
        this.yAxis && (this.groupedBy && this.yAxis.slug === this.groupedBy);
    }.bind(this));

    /**
     * Adapt data for each chart
     */
    const collapseBy = this.collapseBy.slug;
    switch (this.selectedChart) {
      case 'bars':
        if ((this.xAxis && this.xAxis.slug === 'categories' && this.xAxis.type === 'linear') ||
          (this.yAxis && this.yAxis.slug === 'categories' && this.yAxis.type === 'linear')) {

          resultData = resultData.filter(function (d) {
            if (d.year) {
              d.year += '';
            }
            return !Number.isNaN(d['categories']);
          });
        } else {
          resultData = resultData.map(function (d) {
            d.year += '';
            return d;
          });
        }
        break;
      case 'heatmap': // Heatmap
        resultData = resultData.map(function (d) {
          if (d.year) {
            d.year += '';
          }
          return d;
        }.bind(this));
        break;
      case 'spineplot': // Spineplot
        resultData = resultData.map(function (obj) {
          if (obj.year) {
            obj.year += '';
          }
          return obj;
        }.bind(this));
        if (this.selectedFilters['unidad'] === 'Porcentaje') {
          // Calculating representative percentage of the expansion factor
          _.forEach(resultData, function (element) {
            element[collapseBy] = (element.totalByGroup / _.sumBy(resultData, 'totalByGroup')) * 100;
          });
        }
        break;
      default:
        resultData = resultData;
        break;
    }

    /**
     * Filter data by legend options active
     */
    resultData = resultData.filter(function (d) {
      if (considerLegendOptions) {
        if (this.selectedChart === 'map') {
          return this.legendOptions.filter(o => o.active).map(o => o.id).includes(d.id);
        } else {
          let slug = '';
          if (this.groupedBy && this.groupedBy !== this.xAxis.slug) {
            const unCheckedNames = this.legendOptions.filter(o => !o.active).map(o => o.name);
            for (let index = 0; index < unCheckedNames.length; index++) {
              const name = unCheckedNames[index];
              delete d[name];
            }
            if (this.legendOptions[0] !== 'Total') {
              this.groupByOptions = this.legendOptions.filter(o => o.active).map(o => o.name + '');
            }
          } else if (this.legendTitle === this.yAxis.name) {
            slug = this.yAxis.slug;
          } else if (this.legendTitle === this.xAxis.name) {
            slug = this.xAxis.slug;
          }

          return !slug || this.legendOptions.filter(o => o.active).map(o => o.name + '').includes(d[slug] + '');
        }
      } else {
        return true;
      }
    }.bind(this));

    return resultData;
  }

  /**
   * Parses data and returns legendoptions on Object Structure according to kind of chart of data processed
   * @param dataToDraw Data to represent on Charts
   */
  setLegendOptions(dataToDraw) {
    const vm = this;
    // legendOptions by xAxis
    let slug = this.xAxis.slug;
    if (this.yAxis.type === 'ordinal') {
      slug = this.yAxis.slug;
    }
    if (this.groupedBy) {
      slug = this.groupedBy;
    }
    if (this.selectedFilters[this.xAxis.slug] && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[this.xAxis.slug])) {
      this.legendOptions = [this.selectedFilters[this.xAxis.slug]].map(function (c) {
        return { name: c, active: true };
      });
    } else if (this.filterOptions[this.xAxis.slug] && this.filterOptions[this.xAxis.slug].length > 0) {
      this.legendOptions = _.uniq(this.filterOptions[this.xAxis.slug].filter(o => o !== ALL && o !== BOTH)).map(function (c) {
        return { name: c, active: true };
      });
    } else {
      this.legendOptions = _.uniq(this.dataToDraw.map(function (o) { return o[this.xAxis.slug]; }.bind(this))
        .filter(o => o !== ALL && o !== BOTH)).map(function (c) {
          return { name: c, active: true };
        });
    }
    this.legendTitle = this.xAxis.name;

    // legendOptions by groupedBy
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[this.groupedBy])) {
      this.legendOptions = [this.selectedFilters[this.groupedBy]].map(function (c) {
        return { name: c, active: true };
      });
    } else if (this.groupedBy) {
      this.legendOptions = _.uniq(this.filterOptions[this.groupedBy].filter(o => o !== ALL && o !== BOTH)).map(function (c) {
        return { name: c, active: true };
      });
      const foundAxis = _.find(this.axisOptions, { 'slug': this.groupedBy });
      this.legendTitle = foundAxis && this.groupedBy !== 'estado_residencia' ? foundAxis['name'] : 'Unidad geográfica';
    } else if (this.yAxis && this.yAxis.type === 'ordinal') {
      // legendOptions by yAxis
      if (this.selectedFilters[this.yAxis.slug] && !_.includes([ALL, BOTH, NATIONAL], this.selectedFilters[this.yAxis.slug])) {
        this.legendOptions = [this.selectedFilters[this.yAxis.slug]].map(function (c) {
          return { name: c, active: true };
        });
      } else {
        this.legendOptions = _.uniq(dataToDraw.map(function (o) { return o[this.yAxis.slug]; }.bind(this))).map(function (c) {
          return { name: c, active: true };
        });
      }
      this.legendTitle = this.yAxis.name;
    }
    // Filter legendOptions based on dataToDraw
    if (this.dataToDraw && this.dataToDraw.length > 0) {
      if (this.groupedBy === '') {
        this.legendOptions = this.legendOptions.filter(o => {
          // Check if value is set in property
          return _.includes(vm.dataToDraw.map(d => d[slug]), o.name);
        });
      } else {
        this.legendOptions = this.legendOptions.filter(o => {
          // Keep keys from all objects
          return _.includes(vm.dataToDraw.reduce((keys, obj) => _.uniq(keys.concat(Object.keys(obj))), []), o.name);
        });
      }
    }
    this.colorCheckboxes();
  }

  /**
   * Reads legendOptions used by chart, create checkboxes based on that data
   * assign a color to match color of charts
   */
  colorCheckboxes() {
    let colors = this.colors;
    if (colors.length > this.legendOptions.length) {
      colors = this.colors.slice(0, this.legendOptions.length).reverse();
    }
    setTimeout(function () {
      const selection = d3.selectAll('.checkbox-layout-tablet .mat-checkbox-background');
      if (selection.nodes().length > 0) {
        selection
          .style('background-color', function (d, i) {
            return colors[i % colors.length];
          }.bind(this));
      }
    }.bind(this), 0);
  }

  /**
   * Draw chart, only SVG DOM operations
   * @param {Array<Entry>} dataToDraw - filtered data to be drawn
   */
  drawChart(dataToDraw) {
    const considerLegendOptions = true;
    this.filteredData = this.parseData(dataToDraw, considerLegendOptions);
    d3.select('.empty-chart').style('border', null);
  }

  /**
   * Change selected chart
   * @param index - Index from 1 to 6 of current chart selected
   */
  selectChart(chartName: string) {
    this.selectedChart = chartName;
    this.disabledXAxis = false;
    this.disabledYAxis = this.selectedChart === 'bars' ? true : false;
    this.setColorPalette();
    this.setDefaultAxes();
    if (!_.includes(['heatmap', 'spineplot'], this.selectedChart)) {
      this.updateChart();
    }
  }
  /**
   * Toggles the display of panel
   * @param showPanel True if desired to show panel
   */
  toggleShareOptions(showPanel) {
    this.sharePage = showPanel;
  }

  /**
   * Changes the way of sort the chart data
   * @param prop string with value to read in order to change the way of sort the chart data
   */
  sortChanged(prop) {
    const ordinalAxis = _.findIndex([this.xAxis, this.yAxis], o => o.type === 'ordinal');
    if (prop === 'names') {
      this.sortBy.names = true;
      this.sortBy.valuesAscending = false;
      this.sortBy.valuesDescending = false;
      this.orderBy = ordinalAxis === 1 ? this.yAxis.slug : this.xAxis.slug;
    } else if (prop === 'valuesAscending') {
      this.sortBy.names = false;
      this.sortBy.valuesAscending = true;
      this.sortBy.valuesDescending = false;
      this.orderBy = ordinalAxis === 1 ? this.xAxis.slug : this.yAxis.slug;
    } else if (prop === 'valuesDescending') {
      this.sortBy.names = false;
      this.sortBy.valuesAscending = false;
      this.sortBy.valuesDescending = true;
      this.orderBy = ordinalAxis === 1 ? this.xAxis.slug : this.yAxis.slug;
    }

    this.setLegendOptions(this.dataToDraw);
    this.drawChart(this.dataToDraw);
  }

  /**
   * When click on a checkbox right to chart
   * Able or disable it and the color of chart adata correspondig to checkbox
   * @param legendOptions legendoptions to work with
   * @param legendName name to filterlegendoptions
   * @param event event to know if disable o able a checkbox
   */
  onLegendClickCheckbox(legendOptions, legendName, event) {
    let index = 0;
    const unchecks = this.checkboxStillEnabled(legendOptions);
    if (unchecks > 2) {
      legendOptions.find(function (element) {
        if (element.name === legendName) {
          legendOptions[index].active = !legendOptions[index].active;
        }
        index++;
      });
      this.checkboxDisabled = false;
      this.onLegendClick(legendOptions);
    } else if (unchecks === 2) {
      legendOptions.find(function (element) {
        if (element.name === legendName) {
          legendOptions[index].active = !legendOptions[index].active;
        }
        index++;
      });
      if (event.checked === false) { // If disabled one of the 2 checkboxes left
        this.checkboxDisabled = true;
      }
      this.onLegendClick(legendOptions);
    } else if (unchecks === 1) {
      legendOptions.find(function (element) {
        if (element.name === legendName) {
          legendOptions[index].active = true;
        }
        index++;
      });
      this.checkboxDisabled = false;
      this.onLegendClick(legendOptions);
    }
  }

  /**
   * IF there's a checkbox disabled when selected new chart, reenable
   * @param legendOptions legendoptions to work with
   */
  checkboxStillEnabled(legendOptions) {
    let counter = 0;
    for (let i = 0; i < legendOptions.length; i++) {
      if (legendOptions[i].active === true) {
        counter++;
      }
    }
    return counter;
  }

  /**
   * Reads options
   * @param legendOptions legendoptions to work with
   */
  onLegendClick(legendOptions) {
    this.legendOptions = legendOptions;
    this.drawChart(this.dataToDraw);
  }

  /**
   * Reads which filters ar being used according if variable kind it's column or categorie
   */
  filtersConfig() {
    const config = {
      names: {
        unidad: 'Unidad',
        columns: this.selectedQuestion ? this.selectedQuestion.categoryName : 'Variable',
        categories: this.selectedQuestion ? this.selectedQuestion.subcategoryName || this.selectedQuestion.categoryName : 'Categoría',
        secondColumns: this.selectedQuestion ? this.selectedQuestion.categoryName : 'Variable',
        secondCategories: this.selectedQuestion ?
          this.selectedQuestion.subcategoryName || this.selectedQuestion.categoryName : 'Categoría',
      },
      disabled: {
        unidad: {
          'Total': false,
          'Porcentaje': false,
          'Promedio': this.collapseBy && this.collapseBy.slug === this.selectedQuestion.expFactor
            && this.selectedChart !== 'heatmap' && this.selectedChart !== 'spineplot'
        },
        columns: false, // this.groupedBy === 'columns',
        categories: this.selectedQuestion.kind === 'columna',
        secondColumns: false, // this.groupedBy === 'secondColumns',
        secondCategories: false, // this.groupedBy === 'secondCategories'
      }
    };
    if (this.selectedQuestion && this.selectedQuestion.fieldOptions) {
      this.selectedQuestion.fieldOptions.forEach(option => {
        if (!config.names[option.slug]) {
          config.names[option.slug] = option.name;
          config.disabled[option.slug] = false;
        }
      });
    }
    return config;
  }

  /**
   * Function not used
   */
  secondFiltersConfig() {
    return {
      names: {
        columns: this.selectedQuestion ? this.selectedQuestion.categoryName : 'Variable',
        categories: this.selectedQuestion ?
          this.selectedQuestion.subcategoryName || this.selectedQuestion.categoryName : 'Categoría'
      },
      disabled: {
        columns: this.groupedBy === 'columns',
        categories: this.groupedBy === 'categories'
      }
    };
  }

  /**
   * sets value to false to enable Coeficiente
   * @param chart reads if chart has attribute to enable coeficiente
   */
  onChartLoaded(chart) {
    this.enableCoeficiente = false;
  }

  /**
   * Closes the subscrib method to make requests
   */
  ngOnDestroy() {
    this.subQueryParams.unsubscribe();
  }

  /**
   * Works on Variable Autocomplete, returns name of variables according what's being typed
   * @param name value of what is being typed
   */
  filterVariables(name: string) {
    if (typeof name === 'string') {
      return this.variables.filter(variable =>
        variable.shortName.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['question']) {
      return this.variables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.shortName).indexOf(this.utils.stripSpecialCharacters(name['question'])) > -1);
    }
  }

  /**
   * gets the event with value of variable selected, the topic and subtopic for that variable
   * @param event Object containing value of variable selected
   */
  selectVariable(event) {
    this.selectedQuestion = this.searchQuestion.value;
    this.selectedTopic = this.allTopics.find((o) => {
      return o.slug === this.selectedQuestion.topic;
    });
    this.selectedSubtopic = this.subtopics.find((o) => {
      return o.slug === this.selectedQuestion.subtopic;
    });
    this.setOptions();
  }

  /**
   * Sorts names of variables alphabetically
   * @param a name of first variable to compare
   * @param b name of second variable to compare
   */
  sortVariables(a, b) {
    return a.shortName.localeCompare(b.shortName, undefined, { numeric: true });
  }

  /**
   * Sorts names of groups alphabetically
   * @param a name of first group to compare
   * @param b name of second group to compare
   */
  sortGroups(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  /**
   * Sets groupItems according to Chart data and calls sort function to order them
   */
  generateGroupItems() {
    const items = Object.assign({}, this.axisOptions);

    this.groupByItems = _.filter(items, item => {
      return item.type === 'ordinal';
    });
    this.groupByItems.push({
      name: 'Sin desagregación',
      type: 'ordinal',
      slug: ''
    });

    this.groupByItems = this.groupByItems.sort(this.sortGroups);
  }

  /**
   * Generate the selected filters for chart according to ir's data and sets their values to default
   */
  generateSelectedFilters() {
    Object.keys(this.filterOptions).forEach(function (fk) {
      if (fk === 'unidad') {
        this.selectedFilters[fk] = this.selectedQuestion.kindAnswer === CATEGORICAL_QUESTION ? 'Porcentaje' : 'Promedio';
      } else if (this.filterOptions[fk][0]) {
        this.selectedFilters[fk] = this.filterOptions[fk][0];
      } else {
        this.selectedFilters[fk] = ALL;
      }
    }.bind(this));
  }

  /**
   * Shows a note describing if the people that asked for information and was denied
   */
  includedQuestion() {
    return (this.selectedQuestion && this.selectedQuestion.shortName.indexOf('Barreras de acceso a información gubernamental') > -1);
  }

  /**
   * Reads type of screen when using the module, and go between mobile and desktop
   */
  switchDataView() {
    this.switchViewMob = !this.switchViewMob;
  }

  /** Screen width resizing listener  */
  @HostListener('window:resize', ['$event'])

  /**
   * Reads if size of screen is changing
   * @param event Not used
   */
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 600) { // Lower than mobile screen width
      this.enableMobileMenu = true;
    } else {
      this.enableMobileMenu = false;
    }
  }

  /**
   * Called when click to reset filters mto use on chart
   * And the first time when displaying a chart on module
   */
  onResetFilters() {
    this.setDefaultAxes();
  }

  /** Toggle Axes x - y and viceverse  */
  toggleAxes() {
    const tmpAxes = this.xAxisOptions;
    this.xAxisOptions = this.yAxisOptions;
    this.yAxisOptions = tmpAxes;
    const tmp = this.yAxis;
    this.yAxis = _.find(this.yAxisOptions, { slug: this.xAxis.slug });
    this.xAxis = _.find(this.xAxisOptions, { slug: tmp.slug });
    if (this.selectedChart === 'heatmap' || this.selectedChart === 'spineplot') {
      this.disabledYAxis = this.disabledXAxis = false;
      this.groupedBy = this.yAxis.type === 'ordinal' ? this.yAxis.slug : '';
    } else {
      this.disabledYAxis = !this.disabledYAxis;
      this.disabledXAxis = !this.disabledXAxis;
    }
    this.drawChart(this.dataToDraw);
  }

  /** Toggles the visibility of labels if button is selected */
  showLabels() {
    this.labelsVisible = !this.labelsVisible;
    this.showSizeOption = false;
  }

  /** Display a mini Card to select a palette of colors  */
  showColors() {
    this.showColorsOptions = !this.showColorsOptions;
    this.showLabelsOptions = false;
    this.showSizeOption = false;
  }

  /**
   * Show 2 buttons to change size of labels
   */
  showSize() {
    this.showSizeOption = !this.showSizeOption;
    this.showLabelsOptions = false;
    this.showColorsOptions = false;
  }

  /**
   * On clicked if possible Stcks bars of barchart
   */
  toggleStackedOrGrouped() {
    this.stackBy = !this.stackBy;
    this.drawChart(this.dataToDraw);
  }

  /**
   * assign palette selected, to
   * @param palette Palette of colors selected
   */
  selectPalette(palette) {
    this.colors = palette;
    if (this.dataToDraw) {
      this.drawChart(this.dataToDraw);
    }
  }

  /**
   * increase the size of labels on the chart
   */
  increaseSize() {
    this.fontBars = d3.selectAll('.dbox-label').style('font-size', () => {
      this.resBars = parseFloat(d3.selectAll('.dbox-label').style('font-size').split('%')[0]);
      this.resBars += 2.5;
      return this.resBars + 'px';
    });
    return this.fontBars;
  }

  /**
   * Decrease the size of labels on the chart
   */
  decreaseSize() {
    this.fontBars = d3.selectAll('.dbox-label').style('font-size', () => {
      this.resBars = parseFloat(d3.selectAll('.dbox-label').style('font-size').split('%')[0]);
      this.resBars -= 2.5;
      return this.resBars + 'px';
    });
    return this.fontBars;
  }

  /**
   * return true if color intersection is bigger than 5
   * @param palette palette of colors selected
   */
  paletteIsSelected(palette) {
    return _.intersection(this.colors, palette).length > 5;
  }

  /**
   * Is used to Displays on Autocomplete value of variable selected
   * @param variable Variable selected
   */
  displayFn(variable?: Question): string | undefined {
    return variable ? variable.shortName : undefined;
  }

  /**
   * Is used to Displays on Autocomplete value of subtopic selected
   * @param st Subtopic selected
   */
  displayFnSubtopic(st): string | undefined {
    return st ? st.name : undefined;
  }

  /**
   * Is used to Displays on Autocomplete value of topic selected
   * @param qn Topic selected
   */
  displayFn3(qn?: { name: string, slug: string }): string | undefined {
    return qn ? qn.name : undefined;
  }

  /**
   *  Sets to null the value of topic autocomplete
   */
  eraseSearchTopics() {
    this.searchTopic.setValue(undefined);
  }

  /**
   *  Sets to null the value of subtopic autocomplete
   */
  eraseSearchSubtopics() {
    this.searchSubtopic.setValue(undefined);
  }

  /**
   *  Sets to null the value of variable autocomplete
   */
  eraseSearchQuestion() {
    this.searchQuestion.setValue(undefined);
  }
}



// WEBPACK FOOTER //
// ./src/app/endosig/endosig-graphs/endosig-graphs.component.ts